module.exports = __webpack_public_path__ + "static/media/Barcode-amico.f0399fde.svg";